import UserAdapter from '../adapters/UserAdapter';
import Cookies from 'universal-cookie';
import axios from 'axios'
import UrlBase from './../../api/UrlBase'; 

export default class {
    constructor() {
        this.userAdapter = new UserAdapter();
    };

    getContext() {
        /*const context = process.env.REACT_APP_FACTORING;//¿?nombre del factoring
        return context;*/
        return '';
    };

    /*getUsername(user) {
        let prefix = this.getContext().toLowerCase();
        const username = `${prefix}-${user}`;
        return username;
    };*/

    signIn(rut, password) {
        let self = this;
        let jsonDataObj = {   id: rut,
            password: password
        };
        return new Promise(function(resolve, reject){
            axios.post(UrlBase+'jwt-auth/api/login.php', 
            jsonDataObj, 
            {headers: {'Accept': 'application/json'}})
            .then(function (response) {
                let cookies = new Cookies();
                //cookies.set('jwt', response.data.jwtToken, { path: '/', httpOnly: true });
                cookies.set('jwt', response.data.jwtToken, { path: '/' });    
                resolve(self.userAdapter.createUser(response.data));
            })
            .catch(function (error) {
                reject(error);
            });       
        }); 
    };

    signUp(email, password, registerType, customAttributes) {      
        let attributes = {
            'email': email,
            'tipousuario': registerType,
            'password': password
        };
        for(let key in customAttributes) {
            attributes[`${key}`] = customAttributes[key];
        };   
        let jsonDataObj = {   
            email: email,
            password: password,
            id: attributes.rut,
            nombres: attributes.nombres,
            apellidos: attributes.apellidos,
            direccion: attributes.direccion,
            comuna: attributes.comuna,
            telefono: attributes.telefono
        }; 
        return new Promise(function(resolve, reject){
            axios.post(UrlBase+'jwt-auth/api/create_user.php', 
            jsonDataObj, 
            {headers: {'Accept': 'application/json'}})
            .then(function (response) {
                resolve(true);
            })
            .catch(function (error) {
                reject(error);
            });       
        });  
    };

    // async changePassword(user, newPassword) {
        // const loggedUser = await Auth.completeNewPassword(
            // user,               // the Cognito User Object
            // newPassword,       // the new password            
        // );
    // }

    confirmSignUp(email, code) {
        /*const username = this.getUsername(email);

        return new Promise((resolve, reject) => {
            Auth.confirmSignUp(
                username, 
                code, 
                {
                     forceAliasCreation: true    
                }
            )
            .then(()  => resolve(true))
            .catch(error => reject(error.code));
        });*/  
    };

    signOut() {
        return new Promise((resolve, reject) => {
            /*let cookies = new Cookies();  
            //cookies.remove('jwt', { path: '/', httpOnly: true });
            cookies.remove('jwt', { path: '/' });
            if(cookies.get('jwt') === undefined){
                resolve(true);
            }else{  
                reject('Error inesperado.');
            }*/
            let cookies = new Cookies();
            if(cookies.get('jwt') !== undefined){
                cookies.remove('jwt', { path: '/' });
                resolve(true);
            }else{
                reject('Error inesperado.');
            }
        });
    };

    getCurrentUser() {
        return new Promise((resolve, reject) => {
            let self = this;
            let cookies = new Cookies();
            if(cookies.get('jwt') !== undefined){
                let jsonDataObj = { jwt: cookies.get('jwt') }; 
                axios.post(UrlBase+'jwt-auth/api/validate_token.php', 
                jsonDataObj, 
                {headers: {'Accept': 'application/json'}})
                .then(function (response) {
                    //let cookies = new Cookies();
                    //cookies.set('jwt', response.data.jwtToken, { path: '/', httpOnly: true });
                    //cookies.set('jwt', response.data.jwtToken, { path: '/' });

                    resolve(self.userAdapter.createUser(response.data.data));
                })
                .catch(function (error) {
                    reject(error);
                });    
            }else{
                reject('Error inesperado.');
            }
        });
    };

    updateUser(datos) {
        return new Promise((resolve, reject) => {
            let self = this;
            let cookies = new Cookies();
            if(cookies.get('jwt') !== undefined){
                let jsonDataObj = { jwt: cookies.get('jwt') }; 
                axios.post(UrlBase+'jwt-auth/api/update_user.php', 
                jsonDataObj, 
                {headers: {'Accept': 'application/json'}})
                .then(function (response) {
                    let cookies = new Cookies();
                    //cookies.set('jwt', response.data.jwtToken, { path: '/', httpOnly: true });
                    cookies.remove('jwt', { path: '/' });
                    cookies.set('jwt', response.data.jwtToken, { path: '/' });
                    resolve(self.userAdapter.createUser(response.data));
                })
                .catch(function (error) {
                    reject(error);
                });    
            }else{
                reject('Error inesperado.');
            }
        });
    };
    
    forgotPassword(email) {
        /*const username = this.getUsername(email);

        return new Promise((resolve, reject) => {
            Auth.forgotPassword(username)
                .then(data => resolve(data))
                .catch(error => reject(error.name));
        });*/
    };

    forgotPasswordSubmit(email, code, newPassword) {
        /*const username = this.getUsername(email);

        return new Promise((resolve, reject) => {
            Auth.forgotPasswordSubmit(username, code, newPassword)
                .then(data => resolve(true))
                .catch(error => {
                    if(error.name) {
                        reject(error.name);
                    } else {
                        reject(error);
                    }
                });
        });*/
    };
        
}